import { createAction, props } from '@ngrx/store';

export const updateTerritories = createAction(
  '[CountriesTerritories] Update territories',
  props<{ territories: string[] | null; allTerritories: boolean }>()
);

export const updateCountry = createAction('[CountriesTerritories] Update Country', props<{ country: string }>());

export const updateCountryAndTerritories = createAction(
  '[CountryTerritories] Update Country And Territories',
  props<{ country: string; territories: string[] | null; allTerritories: boolean }>()
);
